import React, { useMemo, useState } from 'react'
import { Popover } from '@mui/material'
import { useSearchDocumentsVadIvendContext } from 'state/context/SearchDocumentsVadIvendContext'

export default function BranchFilter({
  valueFilter,
  updateFilter,
  dataWareHouse,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const { filters, setFilters, setDataWareHouse } =
    useSearchDocumentsVadIvendContext()

  const handleOpen = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const handleStatusFilterApply = () => {
    const newFilters = {
      ...filters,
      branchOffices: [],
    }
    const updateDataWareHouse = dataWareHouse.map(warehouse => ({
      ...warehouse,
      checked: false,
    }))
    setDataWareHouse(updateDataWareHouse)
    setFilters(newFilters)
    handleClose(null)
  }
  const handleWarehousesFilterApply = () => {
    const newFilters = {
      ...filters,
      pageNumber: 1,
      branchOffices: dataWareHouse
        .filter(warehouse => warehouse.checked)
        .map(warehouse => warehouse.BranchOfficeId),
    }
    setFilters(newFilters)
    handleClose(null)
  }

  const handleCheck = id => {
    const newWarehouses = dataWareHouse.map(warehouse => {
      if (warehouse.BranchOfficeId === id) {
        return {
          ...warehouse,
          checked: !warehouse.checked,
        }
      }
      return warehouse
    })
    setDataWareHouse(newWarehouses)
  }

  const valueInputMemo = useMemo(() => {
    if (valueFilter) {
      return dataWareHouse
        .filter(warehouse => valueFilter.includes(warehouse.BranchOfficeId))
        .map(warehouse => warehouse.BranchOfficeName)
        .join(', ')
    }
    return ''
  }, [valueFilter, dataWareHouse])

  return (
    <div className="input-group">
      <input
        data-testid="input-branch-filter"
        placeholder="Sucursal"
        value={valueInputMemo || ''}
        onClick={handleOpen}
        readOnly
        className="input-select"
      />

      <Popover
        data-testid="modal-branch-filter"
        id="status-filter-popover"
        className="popover-warehouses"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}>
        <div className="filter-popover-warehouses">
          <div className="search-invoice-container-warehouses">
            {dataWareHouse?.length > 0 ? (
              dataWareHouse.map((warehouse, index) => (
                <div
                  className="status-filter-checkbox"
                  key={warehouse.BranchOfficeId}
                  data-testid={`input-branch-option-${index}`}>
                  <input
                    type="checkbox"
                    checked={warehouse.checked}
                    onChange={() => handleCheck(warehouse.BranchOfficeId)}
                    id={warehouse.BranchOfficeId}
                    name={warehouse.BranchOfficeId}
                  />
                  <label htmlFor={warehouse.WarehouseId}>
                    {warehouse.BranchOfficeName}
                  </label>
                </div>
              ))
            ) : (
              <p>No se encontraron resultados...</p>
            )}
          </div>

          <div className="row mt-5">
            <div className="col-6">
              <button
                data-testid="btn-clear-branch-filter"
                className="btn-clear-filter"
                onClick={handleStatusFilterApply}>
                Limpiar
              </button>
            </div>
            <div className="col-6">
              <button
                data-testid="btn-apply-branch-filter"
                className="btn-apply-filter"
                onClick={handleWarehousesFilterApply}>
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </Popover>
    </div>
  )
}
